import {Options} from "highcharts";
import {setDefaultOptions as surveyLabSetDefaultOptions, default as init} from "surveylabJsAssets/chart/charts";
import * as Highcharts from "highcharts";

export function setDefaultOptions(options: Options) {
    const mergedOptions = Highcharts.merge({
        chart: {
            style: {
                fontFamily: '"Roboto", Helvetica, Arial, sans-serif'
            }
        },
        legend: {
            enabled: false
        },
    }, options);

    surveyLabSetDefaultOptions(mergedOptions);
}

export default function () {
    setDefaultOptions({});
    init();
}